import { GraphicElement } from './GraphicElement';
import { Position } from '../Transform/Position';
import { Size } from '../Size';
import { Scale } from '../Transform/Scale';
import { Rotation } from '../Transform/Rotation';
import { Group } from './Group';
export class CustomGraphicElement extends Group {
    constructor(
        engine,
        content = 'default',
        uuid = GraphicElement.generateUUID(),
        position = new Position(),
        size = new Size(),
        options = {},
        scale = new Scale(),
        rotation = new Rotation()
    ) {
        super(engine, uuid, position, size, options, scale, rotation);
        this.type = 'CustomGraphicElement';
        this._content = content;
    }
    get canBeSelected() {
        return this._uuid !== 'graduation';
    }
    static hydrate(data) {
        const customElement = new CustomGraphicElement(
            data._engine,
            data._content,
            data._uuid,
            new Position(),
            new Size(data.originSize._width, data.originSize._height),
            data.options
        );
        customElement.visible = data.visible;
        customElement.content = data._content;
        customElement.transform.resize(new Scale(data.transform._scale._scaleX, data.transform._scale._scaleY));
        customElement.transform.rotate(data.transform._rotation._angle);
        customElement.isInsideTheme = data._isInsideTheme;
        customElement.transform.groupId = data.transform.groupId;
        customElement.colorGroups = data._colorGroups;
        if (data.transform._localPos) {
            customElement.transform.localPos = new Position(data.transform._localPos._x, data.transform._localPos._y);
        } else {
            customElement.transform.moveTo(new Position(data.transform._pos._x, data.transform._pos._y));
        }
        return customElement;
    }
}
